import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/widgets/middleware/theme';
import { Icon } from '../icon';
import css from '../css/speed-dial.m.css';
import { ActionButton } from './action-button';
const icache = createICacheMiddleware();
const factory = create({ icache, theme }).properties();
export const SpeedDial = factory(({ properties, children, middleware: { icache, theme } }) => {
    const { direction = 'left', onOpen, onClose, faname = 'plus', stickyOpen = false } = properties();
    const open = icache.getOrSet('open', false);
    const themeCss = theme.classes(css);
    const toggleOpen = () => {
        const open = icache.get('open');
        if (!open) {
            icache.set('open', true);
            onOpen && onOpen();
        }
    };
    const toggleClose = () => {
        const open = icache.get('open');
        if (open) {
            icache.set('open', false);
            onClose && onClose();
        }
    };
    let cssDirection = themeCss.right;
    switch (direction) {
        case 'left':
            cssDirection = themeCss.left;
            break;
        case 'right':
            cssDirection = themeCss.right;
            break;
        case 'down':
            cssDirection = themeCss.down;
            break;
        case 'up':
            cssDirection = themeCss.up;
            break;
    }
    const openCss = open ? [themeCss.open] : [];
    const altText = 'Menu';
    return v('div', { key: 'root', classes: [themeCss.root, cssDirection] }, [
        w(ActionButton, {
            size: 'large',
            title: altText,
            aria: { label: altText || '' },
            onClick: (event) => {
                event.stopPropagation();
                if (icache.get('open')) {
                    toggleClose();
                }
                else {
                    toggleOpen();
                }
            },
            expanded: open,
            onOver: () => toggleOpen()
        }, [w(Icon, { faname, altText, xqa: 'main menu' })]),
        v('div', {
            key: 'menu-flyout',
            classes: [themeCss.actions, ...openCss],
            onclick: (event) => {
                event.stopPropagation();
                !stickyOpen && toggleClose();
            }
        }, children())
    ]);
});
